define('selerix_common/vues/pages/login/linked-modals/LinkedModals.vue', ['vue', 'selerix_common/vues/components/linked-modals/LinkedModals.vue'], function (Vue, LinkedModals) {
    'use strict';
    Vue = Vue && Object.prototype.hasOwnProperty.call(Vue, 'default') ? Vue['default'] : Vue;
    LinkedModals = LinkedModals && Object.prototype.hasOwnProperty.call(LinkedModals, 'default') ? LinkedModals['default'] : LinkedModals;
    var script = {
        mount: function (el, model) {
            return new Vue({
                el: el,
                components: {
                    'linked-modals': LinkedModals
                },
                data: {
                    modals: model
                }
            });
        },
        standardMount: function (termsPage, privacyPage, securityPage) {
            return this.mount('#modals-vue', [
                {
                    'id': 'privacy-policy-dialog',
                    'title': 'Privacy Policy',
                    'theme': 'primary',
                    'url': privacyPage || 'privacy-policy.html',
                    'buttons': ['terms-of-use-dialog', 'security-information-dialog', 'hipaa-notice-dialog']
                },
                {
                    'id': 'security-information-dialog',
                    'title': 'Security Information',
                    'theme': 'primary',
                    'url': securityPage || 'security-information.html',
                    'buttons': ['terms-of-use-dialog', 'privacy-policy-dialog', 'hipaa-notice-dialog']
                },
                {
                    'id': 'terms-of-use-dialog',
                    'title': 'Terms of Use Agreement',
                    'theme': 'primary',
                    'url': termsPage || 'terms-of-use.html',
                    'buttons': ['privacy-policy-dialog', 'security-information-dialog', 'hipaa-notice-dialog']
                },
                {
                    'id': 'hipaa-notice-dialog',
                    'title': 'HIPAA Notice',
                    'theme': 'primary',
                    'url': 'hipaa-notice.html',
                    'buttons': ['terms-of-use-dialog', 'privacy-policy-dialog', 'security-information-dialog']
                }
            ]);
        }
    };
    function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
        if (typeof shadowMode !== 'boolean') {
            createInjectorSSR = createInjector;
            createInjector = shadowMode;
            shadowMode = false;
        }
        var options = typeof script === 'function' ? script.options : script;
        if (template && template.render) {
            options.render = template.render;
            options.staticRenderFns = template.staticRenderFns;
            options._compiled = true;
            if (isFunctionalTemplate) {
                options.functional = true;
            }
        }
        if (scopeId) {
            options._scopeId = scopeId;
        }
        var hook;
        if (moduleIdentifier) {
            hook = function (context) {
                context =
                    context ||
                        (this.$vnode && this.$vnode.ssrContext) ||
                        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext);
                if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                    context = __VUE_SSR_CONTEXT__;
                }
                if (style) {
                    style.call(this, createInjectorSSR(context));
                }
                if (context && context._registeredComponents) {
                    context._registeredComponents.add(moduleIdentifier);
                }
            };
            options._ssrRegister = hook;
        }
        else if (style) {
            hook = shadowMode
                ? function (context) {
                    style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
                }
                : function (context) {
                    style.call(this, createInjector(context));
                };
        }
        if (hook) {
            if (options.functional) {
                var originalRender_1 = options.render;
                options.render = function renderWithStyleInjection(h, context) {
                    hook.call(context);
                    return originalRender_1(h, context);
                };
            }
            else {
                var existing = options.beforeCreate;
                options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
            }
        }
        return script;
    }
    var __vue_script__ = script;
    var __vue_inject_styles__ = undefined;
    var __vue_scope_id__ = undefined;
    var __vue_module_identifier__ = undefined;
    var __vue_is_functional_template__ = undefined;
    var __vue_component__ = normalizeComponent({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
    return __vue_component__;
});
